import { useLanguageStore } from '$/store/languageStore';

/** 订阅完整语言资源，空态复用 Smartcat 文案并将项目提示中的换行标签转为纯文本换行。 */
export function useRoleSelectCopy() {
  const language = useLanguageStore((state) => state.languageStore);
  /** 只复用正式 Smartcat key；回退文本均来自接线前相同位置的既有文案。 */
  const read = (key: string, original = '') => language.smartcatTranslationText((text) => text[key]) || original;
  return {
    title: read('RoboNeo_Web_ip_asset_title', '角色IP'),
    personal: read('RoboNeo_Web_ip_roleSelect_personal', '个人'),
    official: read('official', '官方'),
    personalEmpty: read('personal_character_ip_has_not_yet', '暂未创建个人角色IP'),
    officialEmpty: read('RoboNeo_Web_ip_roleSelect_officialEmpty', '暂无官方角色IP'),
    homeUnavailable: read('RoboNeo_Web_ip_roleSelect_homeUnavailable', '登录并完成初始化后可选择角色 IP'),
    roomUnavailable: read('RoboNeo_Web_ip_roleSelect_roomUnavailable', '当前房间角色暂不可用'),
    roomPersonalEmpty: read('project_is_not_yet_associated_with', '项目暂未关联个人角色IP开始聊天新建吧～').replace(/<br\s*\/?\s*>\s*/gi, '\n'),
    roomOfficialEmpty: read('RoboNeo_Web_ip_roleSelect_roomOfficialEmpty', '项目暂未关联官方角色IP'),
    createRole: read('RoboNeo_Web_ip_creation_createRole', '创建角色IP'),
    retry: read('roboneo_web_retry', '重试'),
    loading: read('RoboNeo_Web_loading', '正在加载…'),
    loadFailed: read('RoboNeo_Web_ip_shared_loadError', '角色 IP 加载失败，请重试'),
    createFailed: read('RoboNeo_Web_chat_send_fail') || read('RoboNeo_Web_ip_shared_loadError'),
  };
}
